import { connect } from 'react-redux'
import ScreenShareButton from './ScreenShareButton'
import trackActions from '../../dataStore/actions/tracks'
import { mediaType } from '@bt-react/constants'
import { State } from '../../dataStore/reducers/reducerType'
import { ScreenShareButtonProps } from './types'
import { setAutoSpotlight } from '../../dataStore/actions/room/room'

type Dispatch = 'publishScreen'
const mapStateToProps = (state: State): Omit<ScreenShareButtonProps, Dispatch> => ({
  selected: state.room.mediaType === mediaType.SCREENSHARE && state.syncUi.screenShareFocus === state.user.BTID,
  currentMediaType: state.room.mediaType,
  presenterLayoutsActive: state.layouts.presenterLayout.presenterLayoutsActive
})

const mapDispatchToProps = (dispatch): Pick<ScreenShareButtonProps, Dispatch> => ({
  publishScreen: (presenterLayoutsActive) => {
    dispatch(trackActions.publishScreen())
    if (!presenterLayoutsActive) dispatch(setAutoSpotlight(true))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ScreenShareButton)
